import { DocumentGridViewItem } from "../models/DocumentGridViewItem";

const newDocumentAgeInDays = 14;
const millisecondsPerDay = 24 * 60 * 60 * 1000;

export const isDocumentModifiedWithinNewIndicatorWindow = (
  modifiedTimeInUTC: string | undefined,
  now: Date = new Date()
): boolean => {
  if (!modifiedTimeInUTC) {
    return false;
  }

  const modifiedTime = new Date(modifiedTimeInUTC).getTime();

  if (Number.isNaN(modifiedTime)) {
    return false;
  }

  const cutoffTime = now.getTime() - newDocumentAgeInDays * millisecondsPerDay;
  return modifiedTime >= cutoffTime;
};

export const shouldShowPublishedDocumentNewIndicator = (
  item: Pick<DocumentGridViewItem, "latestComment" | "modifiedTimeInUTC">,
  now: Date = new Date()
): boolean =>
  !item.latestComment?.hidden &&
  isDocumentModifiedWithinNewIndicatorWindow(item.modifiedTimeInUTC, now);
